import { css } from '@emotion/react';
import {
  type FC, useCallback, useEffect, useState,
} from 'react';
import { type ColorResult } from '~/_shared/components/colorPicker/colorPicker.types';
import { ColorPickerWithColorTileComponent } from '~/_shared/components/colorPicker/colorPickerWithColorTile/colorPickerWithColorTile.component';
import { ColorPickerWithWheelComponent } from '~/_shared/components/colorPicker/colorPickerWithWheel/colorPickerWithWheel.component';
import { useDebounce } from '~/_shared/utils/hooks/useDebounce';

const COLOR_TILE_DIMENSION = 16;

const wrapperStyle = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
});

const tilePickerStyle = css({
  fontSize: '14px',
});

const colourPickerWheelStyle = css({ justifyContent: 'flex-end' });

type HeatMapColorRowProps = Readonly<{
  className?: string;
  label: string;
  selectedColor: ColorResult;

  onColorChange: (color: ColorResult) => void;
}>;

export const HeatMapColorRowComponent: FC<HeatMapColorRowProps> = (props) => {
  const [internalColor, setInternalColor] = useState(props.selectedColor);

  const propagate = useDebounce(props.onColorChange, 500);

  useEffect(() => {
    setInternalColor(props.selectedColor);
  }, [props.selectedColor, propagate]);

  const handleColorChange = useCallback((newColor: ColorResult) => {
    setInternalColor(newColor);
    propagate(newColor);
  }, [propagate]);

  return (
    <div
      className={props.className}
      css={wrapperStyle}
    >
      <ColorPickerWithColorTileComponent
        css={tilePickerStyle}
        displayAlpha={false}
        height={COLOR_TILE_DIMENSION}
        isFixed
        label={props.label}
        onChange={handleColorChange}
        selectedColor={internalColor}
        width={COLOR_TILE_DIMENSION}
      />

      <ColorPickerWithWheelComponent
        contentStyle={colourPickerWheelStyle}
        displayAlpha={false}
        isFixed
        onChange={handleColorChange}
        selectedColor={internalColor}
      />
    </div>
  );
};
